import React, { useRef } from 'react';
import useDataVersion from '../hooks/useDataVersion';

/**
 * Solar Project Dashboard
 * Renders the SIL Solar Project — Service-wise Estimated vs Actual dashboard.
 * Auto-refreshes when admin publishes new solar-project data.
 */
const SolarProjectPage = () => {
  const iframeRef = useRef(null);

  useDataVersion('solar-project', () => {
    if (iframeRef.current) {
      iframeRef.current.src = iframeRef.current.src.split('?')[0] + '?_=' + Date.now();
    }
  }, { toastLabel: 'Solar Project data' });

  return (
    <div className="w-full h-full min-h-screen bg-white" data-testid="solar-project-page">
      <iframe
        ref={iframeRef}
        src="/solar-project.html"
        title="Solar Project Dashboard"
        className="w-full border-0"
        style={{ height: 'calc(100vh - 4rem)', minHeight: '900px' }}
      />
    </div>
  );
};

export default SolarProjectPage;
